import type { FilterComponentProps } from '@/app/common/filters/core/filterComponentType.ts';
import { FilterMultiSelect } from '@/app/common/filters/types/multiSelect/FilterMultiSelect.tsx';

// A plain checkbox list: no circled icons, no counters, and no "Any" row.
export const MealPlanOverlayMultiSelect = (props: FilterComponentProps) => (
  <FilterMultiSelect {...props} columns={1} showCounter={false} hideDefaultOption={true} />
);
